<template>
  <v-overlay class="text-center align-center justify-center" :model-value="true">
    <v-progress-circular color="primary" indeterminate size="42"></v-progress-circular>
    <p class="text-body-1 mt-4 font-weight-bold">{{ t('yard.messages.loadingYardData') }}...</p>
  </v-overlay>
</template>
<script>
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewLoading',
  setup() {
    const { t } = useI18n();

    return { t };
  }
});
</script>
